var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M23 12.067C23 5.955 18.075 1 12 1S1 5.955 1 12.067c0 5.524 4.022 10.102 9.281 10.932v-7.733H7.488v-3.2h2.793V9.629c0-2.773 1.643-4.306 4.155-4.306 1.203 0 2.463.217 2.463.217v2.724H15.51c-1.367 0-1.793.853-1.793 1.728v2.075h3.05l-.487 3.2h-2.563V23C18.978 22.17 23 17.59 23 12.067z"
})));
export default SvgFacebook;